var duScrollDefaultEasing = function (e) {
  "use strict";

  return .5 > e ? Math.pow(2 * e, 2) / 2 : 1 - Math.pow(2 * (1 - e), 2) / 2;
};

angular.module("duScroll", ["duScroll.scrollspy", "duScroll.smoothScroll", "duScroll.scrollContainer", "duScroll.spyContext", "duScroll.scrollHelpers"]).value("duScrollDuration", 350).value("duScrollSpyWait", 100).value("duScrollGreedy", !1).value("duScrollOffset", 0).value("duScrollEasing", duScrollDefaultEasing), angular.module("duScroll.scrollHelpers", ["duScroll.requestAnimation"]).run(["$window", "$q", "cancelAnimation", "requestAnimation", "duScrollEasing", "duScrollDuration", "duScrollOffset", function (e, t, n, r, o, l, u) {
  "use strict";

  var i = {},
      c = function (e) {
    return "undefined" != typeof HTMLDocument && e instanceof HTMLDocument || e.nodeType && e.nodeType === e.DOCUMENT_NODE;
  },
      a = function (e) {
    return "undefined" != typeof HTMLElement && e instanceof HTMLElement || e.nodeType && e.nodeType === e.ELEMENT_NODE;
  },
      s = function (e) {
    return a(e) || c(e) ? e : e[0];
  };

  i.duScrollTo = function (t, n, r) {
    var o;
    if (angular.isElement(t) ? o = this.duScrollToElement : angular.isDefined(r) && (o = this.duScrollToAnimated), o) return o.apply(this, arguments);
    var l = s(this);
    return c(l) ? e.scrollTo(t, n) : (l.scrollLeft = t, l.scrollTop = n, void 0);
  };

  var d, f;
  i.duScrollToAnimated = function (e, l, u, i) {
    u && !i && (i = o);

    var c = this.duScrollLeft(),
        a = this.duScrollTop(),
        s = Math.round(e - c),
        p = Math.round(l - a),
        m = null,
        g = this,
        S = "scroll mousedown mousewheel touchmove keydown",
        h = function (e) {
      (!e || e.which > 0) && (g.unbind(S, h), n(d), f.reject(), d = null);
    };

    if (d && h(), f = t.defer(), 0 === u || !s && !p) return 0 === u && g.duScrollTo(e, l), f.resolve(), f.promise;

    var v = function (e) {
      null === m && (m = e);
      var t = e - m,
          n = t >= u ? 1 : i(t / u);
      g.scrollTo(c + Math.ceil(s * n), a + Math.ceil(p * n)), 1 > n ? d = r(v) : (g.unbind(S, h), d = null, f.resolve());
    };

    return g.duScrollTo(c, a), g.bind(S, h), d = r(v), f.promise;
  }, i.duScrollToElement = function (e, t, n, r) {
    var o = s(this);
    (!angular.isNumber(t) || isNaN(t)) && (t = u);
    var l = this.duScrollTop() + s(e).getBoundingClientRect().top - t;
    return a(o) && (l -= o.getBoundingClientRect().top), this.duScrollTo(0, l, n, r);
  }, i.duScrollLeft = function (t, n, r) {
    if (angular.isNumber(t)) return this.duScrollTo(t, this.duScrollTop(), n, r);
    var o = s(this);
    return c(o) ? e.scrollX || document.documentElement.scrollLeft || document.body.scrollLeft : o.scrollLeft;
  }, i.duScrollTop = function (t, n, r) {
    if (angular.isNumber(t)) return this.duScrollTo(this.duScrollLeft(), t, n, r);
    var o = s(this);
    return c(o) ? e.scrollY || document.documentElement.scrollTop || document.body.scrollTop : o.scrollTop;
  }, i.duScrollToElementAnimated = function (e, t, n, r) {
    return this.duScrollToElement(e, t, n || l, r);
  }, i.duScrollTopAnimated = function (e, t, n) {
    return this.duScrollTop(e, t || l, n);
  }, i.duScrollLeftAnimated = function (e, t, n) {
    return this.duScrollLeft(e, t || l, n);
  }, angular.forEach(i, function (e, t) {
    angular.element.prototype[t] = e;
    var n = t.replace(/^duScroll/, "scroll");
    angular.isUndefined(angular.element.prototype[n]) && (angular.element.prototype[n] = e);
  });
}]), angular.module("duScroll.polyfill", []).factory("polyfill", ["$window", function (e) {
  "use strict";

  var t = ["webkit", "moz", "o", "ms"];
  return function (n, r) {
    if (e[n]) return e[n];

    for (var o, l = n.substr(0, 1).toUpperCase() + n.substr(1), u = 0; u < t.length; u++) if (o = t[u] + l, e[o]) return e[o];

    return r;
  };
}]), angular.module("duScroll.requestAnimation", ["duScroll.polyfill"]).factory("requestAnimation", ["polyfill", "$timeout", function (e, t) {
  "use strict";

  var n = 0,
      r = function (e) {
    var r = new Date().getTime(),
        o = Math.max(0, 16 - (r - n)),
        l = t(function () {
      e(r + o);
    }, o);
    return n = r + o, l;
  };

  return e("requestAnimationFrame", r);
}]).factory("cancelAnimation", ["polyfill", "$timeout", function (e, t) {
  "use strict";

  var n = function (e) {
    t.cancel(e);
  };

  return e("cancelAnimationFrame", n);
}]), angular.module("duScroll.spyAPI", ["duScroll.scrollContainerAPI"]).factory("spyAPI", ["$rootScope", "$timeout", "$window", "$document", "scrollContainerAPI", "duScrollGreedy", "duScrollSpyWait", function (e, t, n, r, o, l, u) {
  "use strict";

  var i = function (o) {
    var i = !1,
        c = !1,
        a = function () {
      c = !1;
      var t,
          u = o.container,
          i = u[0],
          a = 0;
      "undefined" != typeof HTMLElement && i instanceof HTMLElement || i.nodeType && i.nodeType === i.ELEMENT_NODE ? (a = i.getBoundingClientRect().top, t = Math.round(i.scrollTop + i.clientHeight) >= i.scrollHeight) : t = Math.round(n.pageYOffset + n.innerHeight) >= r[0].body.scrollHeight;
      var s,
          d,
          f,
          p,
          m,
          g,
          S = t ? "bottom" : "top";

      for (p = o.spies, d = o.currentlyActive, f = void 0, s = 0; s < p.length; s++) m = p[s], g = m.getTargetPosition(), g && (t || g.top + m.offset - a < 20 && (l || -1 * g.top + a) < g.height) && (!f || f[S] < g[S]) && (f = {
        spy: m
      }, f[S] = g[S]);

      f && (f = f.spy), d === f || l && !f || (d && (d.$element.removeClass("active"), e.$broadcast("duScrollspy:becameInactive", d.$element)), f && (f.$element.addClass("active"), e.$broadcast("duScrollspy:becameActive", f.$element)), o.currentlyActive = f);
    };

    return u ? function () {
      i ? c = !0 : (a(), i = t(function () {
        i = !1, c && a();
      }, u, !1));
    } : a;
  },
      c = {},
      a = function (e) {
    var t = e.$id,
        n = {
      spies: []
    };
    return n.handler = i(n), c[t] = n, e.$on("$destroy", function () {
      s(e);
    }), t;
  },
      s = function (e) {
    var t = e.$id,
        n = c[t],
        r = n.container;
    r && r.off("scroll", n.handler), delete c[t];
  },
      d = a(e),
      f = function (e) {
    return c[e.$id] ? c[e.$id] : e.$parent ? f(e.$parent) : c[d];
  },
      p = function (e) {
    var t,
        n,
        r = e.$scope;
    if (r) return f(r);

    for (n in c) if (t = c[n], -1 !== t.spies.indexOf(e)) return t;
  },
      m = function (e) {
    for (; e.parentNode;) if (e = e.parentNode, e === document) return !0;

    return !1;
  },
      g = function (e) {
    var t = p(e);
    t && (t.spies.push(e), t.container && m(t.container) || (t.container && t.container.off("scroll", t.handler), t.container = o.getContainer(e.$scope), t.container.on("scroll", t.handler).triggerHandler("scroll")));
  },
      S = function (e) {
    var t = p(e);
    e === t.currentlyActive && (t.currentlyActive = null);
    var n = t.spies.indexOf(e);
    -1 !== n && t.spies.splice(n, 1), e.$element = null;
  };

  return {
    addSpy: g,
    removeSpy: S,
    createContext: a,
    destroyContext: s,
    getContextForScope: f
  };
}]), angular.module("duScroll.scrollContainerAPI", []).factory("scrollContainerAPI", ["$document", function (e) {
  "use strict";

  var t = {},
      n = function (e, n) {
    var r = e.$id;
    return t[r] = n, r;
  },
      r = function (e) {
    return t[e.$id] ? e.$id : e.$parent ? r(e.$parent) : void 0;
  },
      o = function (n) {
    var o = r(n);
    return o ? t[o] : e;
  },
      l = function (e) {
    var n = r(e);
    n && delete t[n];
  };

  return {
    getContainerId: r,
    getContainer: o,
    setContainer: n,
    removeContainer: l
  };
}]), angular.module("duScroll.smoothScroll", ["duScroll.scrollHelpers", "duScroll.scrollContainerAPI"]).directive("duSmoothScroll", ["duScrollDuration", "duScrollOffset", "scrollContainerAPI", function (e, t, n) {
  "use strict";

  return {
    link: function (r, o, l) {
      o.on("click", function (o) {
        if (l.href && -1 !== l.href.indexOf("#")) {
          var u = document.getElementById(l.href.replace(/.*(?=#[^\s]+$)/, "").substring(1));

          if (u && u.getBoundingClientRect) {
            o.stopPropagation && o.stopPropagation(), o.preventDefault && o.preventDefault();
            var i = l.offset ? parseInt(l.offset, 10) : t,
                c = l.duration ? parseInt(l.duration, 10) : e,
                a = n.getContainer(r);
            a.duScrollToElement(angular.element(u), isNaN(i) ? 0 : i, isNaN(c) ? 0 : c);
          }
        }
      });
    }
  };
}]), angular.module("duScroll.spyContext", ["duScroll.spyAPI"]).directive("duSpyContext", ["spyAPI", function (e) {
  "use strict";

  return {
    restrict: "A",
    scope: !0,
    compile: function () {
      return {
        pre: function (t) {
          e.createContext(t);
        }
      };
    }
  };
}]), angular.module("duScroll.scrollContainer", ["duScroll.scrollContainerAPI"]).directive("duScrollContainer", ["scrollContainerAPI", function (e) {
  "use strict";

  return {
    restrict: "A",
    scope: !0,
    compile: function () {
      return {
        pre: function (t, n, r) {
          r.$observe("duScrollContainer", function (r) {
            angular.isString(r) && (r = document.getElementById(r)), r = angular.isElement(r) ? angular.element(r) : n, e.setContainer(t, r), t.$on("$destroy", function () {
              e.removeContainer(t);
            });
          });
        }
      };
    }
  };
}]), angular.module("duScroll.scrollspy", ["duScroll.spyAPI"]).directive("duScrollspy", ["spyAPI", "duScrollOffset", "$timeout", "$rootScope", function (e, t, n, r) {
  "use strict";

  var o = function (e, t, n, r) {
    angular.isElement(e) ? this.target = e : angular.isString(e) && (this.targetId = e), this.$scope = t, this.$element = n, this.offset = r;
  };

  return o.prototype.getTargetElement = function () {
    return !this.target && this.targetId && (this.target = document.getElementById(this.targetId)), this.target;
  }, o.prototype.getTargetPosition = function () {
    var e = this.getTargetElement();
    return e ? e.getBoundingClientRect() : void 0;
  }, o.prototype.flushTargetCache = function () {
    this.targetId && (this.target = void 0);
  }, {
    link: function (l, u, i) {
      var c,
          a = i.ngHref || i.href;
      a && -1 !== a.indexOf("#") ? c = a.replace(/.*(?=#[^\s]+$)/, "").substring(1) : i.duScrollspy && (c = i.duScrollspy), c && n(function () {
        var n = new o(c, l, u, -(i.offset ? parseInt(i.offset, 10) : t));
        e.addSpy(n), l.$on("$destroy", function () {
          e.removeSpy(n);
        }), l.$on("$locationChangeSuccess", n.flushTargetCache.bind(n)), r.$on("$stateChangeSuccess", n.flushTargetCache.bind(n));
      }, 0, !1);
    }
  };
}]);